<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование устройства</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-row">
            <div class="mb-4">
                <label class="form-label">Ключ устройства</label>
                <div class="d-flex align-items-center">
                    <span class="me-3">
                        {{ deviceKey }}
                    </span>
                    <button
                        style="padding:5px;min-width:50px;width:10px;background-color:white;border:1px solid #e6e6e6;"
                        title="Скопировать ключ"
                        class="btn btn-light"
                        @click="copyDeviceKey()"
                    >
                        <svg style="width: 20px;" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path d="M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="input_name_location_id">Адрес <span class="color-red">*</span></label>
                <v-autocomplete
                    v-model="selectedLocation"
                    v-model:search="search"
                    :items="locations"
                    return-object
                    :item-title="formatItemTitle"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-autocomplete>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="input_name_type_id">Статус <span class="color-red">*</span></label>
                <v-select
                    v-model="status_device"
                    :items="statuses"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <span>Данные не найдены</span>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label mt-3">Бренд</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.brand_name }}
                </div>

                <label class="form-label mt-3">График работы</label>
                <div v-if="selectedLocation">
                    {{ selectedLocation.worktime }}
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="ip">IP <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="ip" v-model="ip" placeholder="Введите ip адрес">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="sshPort">SSH PORT <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="sshPort" v-model="sshPort" placeholder="Введите порт">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="content-update-start">Время начала обновления контента устройства <span class="color-red">*</span></label>
                <input type="time" class="form-control" id="content-update-start" v-model="update_start" placeholder="Введите время начала обновления контента устройства">
            </div>
        </div>

        <div class="form-row">
            <div class="mb-4">
                <label class="form-label" for="content-update-interval">Интервал обновления контента устройства <span class="color-red">*</span></label>
                <input type="time" class="form-control" id="content-update-interval" v-model="update_interval" placeholder="Введите интервал обновления контента устройства">
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-start">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="editSend"/>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Device from "../../../../models/Device";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "DeviceEditComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_get: String,
        route_locations_search: String,
        route_worktimes_search: String,
        route_update: String,
        item_id: {
            type: [Number, String],
            default: 0
        },
    },
    data: function () {
        return {
            device: new Device({
                route_get: this.route_get,
                route_update: this.route_update,
                route_locations_search: this.route_locations_search,
                route_worktimes_search: this.route_worktimes_search,
            }),
            statuses: [
                {
                    id: 6,
                    name: 'Не выбрано'
                },
                {
                    id: 3,
                    name: 'На ремонте'
                },
                {
                    id: 4,
                    name: 'Перемещение'
                },
                {
                    id: 5,
                    name: 'Утилизировано/списано'
                },
            ],
            search: '',
            item: {},
            worktimes: {},
            locations: [],
            location_id: 0,
            worktime: '',
            brand: '',
            status_device: null,
            update_interval: null,
            update_start: null,
            ip: null,
            sshPort: null,
            selectedLocation: null,
            addressAndNumber: null,
            isOpenDropDown: false,
            deviceKey: null,
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        getData: async function () {
            const data = await axios.get(this.route_get, {
                params: {
                    id: this.item_id
                }
            }).then(response => {
                return response.data
            });

            this.location_id = data.item.location_id;
            this.update_interval = data.item.update_interval;
            this.update_start = data.item.update_start;
            this.ip = data.item.ip;
            this.sshPort = data.item.ssh_port;
            this.deviceKey = data.item.device_key;
            this.status_device = data.item.status;

            if (data.item.street || data.item.number) {
                this.selectedLocation = {
                    street: data.item.street,
                    number: data.item.number,
                    brand_name: data.item.brand_name,
                    worktime: data.item.worktime,
                }
            }
        },
        worktimeSearch: async function () {
            this.worktimes = await this.device.worktimes();
            this.worktimes = this.worktimes.items;
        },
        locationSearch: async function () {
            const data = await axios.get(this.route_locations_search, {
                params: {
                    address_number: this.addressAndNumber
                }
            }).then(response => {
                return response.data
            });

            this.locations = data.status == "ok" ? data.items : [];
        },
        editSend: async function () {
            if (!this.location_id) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите адрес устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.update_start) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите время начала обновления контента устройства устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.update_interval) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите интервал обновления контента устройства' });
                this.toggleLoading();
                return;
            }

            if (!this.ip) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите IP' });
                this.toggleLoading();
                return;
            }

            if (!this.sshPort) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите SSH PORT' });
                this.toggleLoading();
                return;
            }

            let result = await this.device.update({
                location_id: this.location_id,
                status: this.status,
                update_interval: this.update_interval,
                update_start: this.update_start,
                ssh_port: this.sshPort,
                ip: this.ip,
                status_device: this.status_device
            }, this.item_id);
            if (result) {
                location.href = this.route_back;
            } else {
                console.log('error: edit_device');
                this.toggleLoading();
            }
        },
        copyDeviceKey: async function() {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(this.deviceKey);
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Ключ скопирован!' });
            }
        },
        selectLocation: function (location) {
            this.location_id = location.id;
            this.selectedLocation = {...location};
            this.addressAndNumber = '';
        },
        formatItemTitle(item) {
            return `${item.number} ${item.street}`;
        },
    },
    watch: {
        selectedLocation(location) {
            this.location_id = location?.id ? location.id : null;
            this.addressAndNumber = '';
        }
    },
    mounted() {
        this.getData();
        this.locationSearch();
    }
}
</script>

<style scoped>
    #search_address_input {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    #input_name_location_id {
        border-top: none;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    .app-dropdown {
        border-radius: 5px;
        position: relative;
    }

    .app-dropdown .manager {
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .app-dropdown .items-block {
        position: relative;
        height: 200px;
        overflow: auto;
        z-index: 9999;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .app-dropdown .items-block .searching-block {
        position: sticky;
        top: 0;
        background-color: #fff;
    }

    .app-dropdown .items-block .searching-block input {
        border-bottom: 1px solid #ddd;
        border-top: none;
        border-radius: 0;
        border-left: none;
        border-right: none;
    }

    .app-dropdown .items {
        position: absolute;
        width: 100%;
    }

    .app-dropdown .items .item {
        padding: 0 10px;
        cursor: pointer;
        font-size: 16px;
    }

    .app-dropdown .items .item:hover {
        background-color: #3c7af0;
        color: white;
    }

    .app-dropdown .hidden {
        display: none;
    }

    .app-dropdown .manager {
        padding: 15px;
        height: 40px;
        cursor: pointer;
    }

    .app-dropdown .manager .button {
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
        background-repeat: no-repeat;
        background-position: center right;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 16px;
    }

    .app-dropdown .shade {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 999;
        min-height: 100vh;
        overflow: hidden;
    }

    .app-dropdown .content {
        position: absolute;
        width: 100%;
        height: 200px;
    }
</style>
